
import { useContext } from "react"
import { GaleriaProductos } from "./GaleriaProductos"
import { ProductoContext } from "../context/ProductoContext"

export const Tienda = () => {

  const { listaPiscosPuros, listaPiscosAcholados, listaPiscosMostoVerde } = useContext(ProductoContext)

  return (

    <div className="container" style={{paddingTop:"94px"}}>
      <div className="row">
        <h2 className="mt-4 text-center">PISCOS PUROS</h2>
        <section className="col-12 my-2">
          <GaleriaProductos listaProductos={listaPiscosPuros} />
        </section>
        
        <h2 className="mt-4 text-center">PISCOS ACHOLADOS</h2>
        <section className="col-12 my-2">
          <GaleriaProductos listaProductos={listaPiscosAcholados} />
        </section>
        
        <h2 className="mt-4 text-center">PISCOS MOSTO VERDE</h2>
        <section className="col-12 my-2">
          <GaleriaProductos listaProductos={listaPiscosMostoVerde} />
        </section>
      </div>
    </div>

  )
}
